import "./src/styles/global.css";
// import "./src/styles/scss/index.scss";
import "./src/styles/slides.min.css";
